import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { PageHeader, StatCard } from "@/components/admin/AdminUI";

const money = (v) => `₹${Number(v).toLocaleString("en-IN")}`;

export default function AdminBilling() {
  const [b, setB] = useState(null);

  useEffect(() => {
    api.get("/admin/billing").then((r) => setB(r.data)).catch(() => setB(false));
  }, []);

  if (b === null)
    return <div className="flex h-64 items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-muted-foreground" /></div>;
  if (b === false) return <p className="text-sm text-destructive">Failed to load billing.</p>;

  return (
    <div data-testid="admin-billing">
      <PageHeader title="Billing Pulse" subtitle="Revenue and subscription health (INR)" />
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <StatCard testid="billing-mrr" label="MRR" value={money(b.mrr)} accent hint="Monthly recurring revenue" />
        <StatCard testid="billing-arr" label="ARR" value={money(b.arr)} hint="Annual run rate" />
        <StatCard testid="billing-revenue" label="Revenue this month" value={money(b.revenue_this_month)} />
        <StatCard testid="billing-outstanding" label="Outstanding" value={money(b.outstanding)} hint="Unpaid invoices" />
        <StatCard testid="billing-gst" label="GST collected" value={money(b.gst_collected)} hint="18% GST on paid" />
        <StatCard testid="billing-arpu" label="ARPU" value={money(b.arpu)} hint={`${b.active_subscriptions} active subs`} />
      </div>
    </div>
  );
}
